// DataTable.js

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../hooks/apiClient";
import OrdersTableCom from "./components/OrdersTable";
import { CircularProgress } from "@mui/material";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useStore } from "../../context/StoreContext";
const OrdersTable = () => {
  const { selectedStore, isStoreSelected } = useStore();
  const store_id = isStoreSelected && selectedStore.id;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await api.get(`orders/laam/bystore/${store_id}`);
        setData(response.data);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleRowClick = (id) => {
    navigate(`/laam/orders/${id}`);
  };

  if (loading) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  }
  if (data.length === 0) {
    return (
      <div>
        <SyncProblemIcon />
        {!isStoreSelected && <p>No Store Selected</p>}
      </div>
    );
  }
  return (
    <div>
      <h1>Orders</h1>
      <OrdersTableCom data={data} handleRowClick={handleRowClick} />
    </div>
  );
};

export default OrdersTable;
